import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export const MembershipTypeBasicInfoComponent = ({ types, selectedMembershipType, membership, handleInnerFormChange }: any) => (
        <>
     <AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
        <InputContainer
            label="Name"
            labelField="Name"
            onValueChange={(event: any, newValue: any) => {
              handleInnerFormChange(
                event.target.value,
                'Name'
              );
            }}
            type="text"
            value={selectedMembershipType?.Name}
        />
      <InputContainer
              label="Membership Name"
              labelField="Name"
              list={membership}
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'MembershipId'
                )
              }}
              optionName='Choose Membership'
              type="select"
              value={selectedMembershipType?.MembershipId}
              valueField="Id"
          />
      <InputContainer
              label="Membership Type"
              labelField="Text"
              list={types}
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'TypeId'
                );
              }}
              optionName='Choose MembershipType'
              type="select"
              value={selectedMembershipType?.TypeId}
              valueField="Value"
          />
     </div>
  }
    expandedPanel="BasicInfo"
    headerTitle="Basic Information"
/>
        </>
)
export default MembershipTypeBasicInfoComponent;
